<template>
  <local-map-with-sidebar-page :filter-options="filterOptions"
                               :include-search-field="true"
                               :organisation-boundaries="organisationBoundaries"
                               :prop-filters="propFilters"
                               :search-strategy="searchStrategy"
                               :show-event-type-filter="showEventTypeFilter"
                               :show-label-filter="showLabelFilter"
                               :show-region-filter="showRegionFilter"
                               :show-type-filter="false" />
</template>

<script>
import GeoipCountryMixin from '@/location-search/geoip-country-mixin'
import LocalMapWithSidebarPage from './local-map-with-sidebar-page'
import { FILTER_KEY_PARTNERSHIP } from './filter-keys'
import { sharedMapPropsMixin } from './shared-map-props'

export default {
  components: { LocalMapWithSidebarPage},

  mixins: [ GeoipCountryMixin, sharedMapPropsMixin ],

  props: {
    filterOptions: {
      type: Object,
      required: true
    },
    partnershipSlug: {
      type: String,
      required: true
    },
    showEventTypeFilter: {
      type: Boolean,
      required: true
    },
    showLabelFilter: {
      type: Boolean,
      required: true
    },
    showRegionFilter: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      propFilters: [{
        type: FILTER_KEY_PARTNERSHIP,
        value: this.partnershipSlug
      }]
    }
  },

  created() {
    this.$store.commit('setAdditionalParamsIncludedInEventUrls', {partner: this.partnershipSlug})
    this.$store.commit('setEventCreationAllowed', true)
  }
}
</script>

<style scoped lang="scss">
@use "~common_styles/breakpoints" as breakpoints;

// Set fixed height on large screens to ensure the map height (which is set automatically)
// is the same as the sidebar's height
@include breakpoints.screen-md-up {
  ::v-deep(.sidebar) {
    height: 600px;
  }
}
</style>
